import { IMasterNamePerson, IUser } from '@/models';
import { IBooking } from '@/pages/JMS/Managament/types/booking';

export enum InmateAgeCategory {
  ADULT = 'Adult',
  JUVENILE = 'Juvenile',
}

export enum InmateStatus {
  PROCESSING = 'Processing',
  PROCESSED = 'Processed',
  RELEASED = 'Released',
}

export interface IInmate {
  _id?: string;
  iid?: string;
  masterName?: IMasterNamePerson;
  booking?: IBooking;
  housing?: IInmateHousing;
  location?: FacilityLocation;
}

export interface IInmateNote {
  inmate: IUser | string;
  description: string;
  officer?: IUser | string;
  createdBy: IUser | string;
  createdAt: Date | string;
}

export interface IInmateHousing {
  bed: FacilityLocation | string;
  cell: FacilityLocation | string;
  pod: FacilityLocation | string;
}

export interface FacilityLocation {
  _id: string;
  name: string;
  parent?: FacilityLocation;
}
